import { v4 as uuid } from 'uuid';

import {
    apiGetPublisherButton,
    apiSetPublisherButton,
} from './api';

// No side effects, so concurrent calls for different types (see checkHasPrimaryDisplay)
// can't race to overwrite each other's result in the shared publisherButton field.
async function fetchPublisherButtonNode ({ type, token, traceId }) {
    const res = await apiGetPublisherButton({ type, token, traceId });

    if (res.data && res.data.data && res.data.data.getWidgets) {
        const edges = res.data.data.getWidgets.edges;
        if (edges && edges.length > 0) {
            return edges[0].node;
        }
    }
    return null;
}

export async function getPublisherButton (type = 'button') {
    this.env.errorStore.action = 'getPublisherButton';
    const publisher = this.env.userStore.publisher;

    const node = await fetchPublisherButtonNode({
        type,
        token: publisher.token,
        traceId: this.env.traceId,
    });

    if (node) {
        this.publisherButton = node;
        this.observed.publisherButton = uuid();
    }
    return node;
}

export async function setPublisherButton ({ buttonWidgetId, publicButton }) {
    this.env.errorStore.action = 'setPublisherButton';
    const publisher = this.env.userStore.publisher;

    const res = await apiSetPublisherButton({
        buttonWidgetId,
        publicButton,
        token: publisher.token,
        traceId: this.env.traceId,
    });

    if (res.data && res.data.data && res.data.data.setPublisherButton) {
        const edges = res.data.data.setPublisherButton.edges;
        if (edges && edges.length > 0) {
            this.publisherButton = edges[0].node;
            this.observed.publisherButton = uuid();
        }
    }
}

function isPrimaryDisplaySet (publisherButton) {
    return publisherButton?.publicButton === true;
}

export async function checkHasPrimaryDisplay () {
    this.env.errorStore.action = 'getPublisherButton';
    const publisher = this.env.userStore.publisher;

    const [button, ad] = await Promise.all([
        fetchPublisherButtonNode({ type: 'button', token: publisher.token, traceId: this.env.traceId }),
        fetchPublisherButtonNode({ type: 'ad', token: publisher.token, traceId: this.env.traceId }),
    ]);
    this.hasPrimaryDisplay = isPrimaryDisplaySet(button) || isPrimaryDisplaySet(ad);
    this.observed.hasPrimaryDisplay = uuid();
    return this.hasPrimaryDisplay;
}
